document.addEventListener('DOMContentLoaded', () => {
  $('#indices_financieros').collapse({
    toggle: false
  })
})